export const mapAddressToViewModel = address => ({
  ...address,
  primary: address?.primary ? 'Yes' : 'No',
  notes: address?.notes
});
